import React from "react";

export function BKingIcon({ color = "#5F5955" }: { color?: string }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 121 161"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M70.5795 47.5433V34.1487H87.3606V17.4091H68.7087V2.69922H52.211V17.4129H33.5628V34.1562H50.3439V47.5471"
        fill={color}
      />
      <path
        d="M70.5795 47.5433V34.1487H87.3606V17.4091H68.7087V2.69922H52.211V17.4129H33.5628V34.1562H50.3439V47.5471"
        stroke={color}
        stroke-width="4.53543"
        stroke-linecap="round"
      />
      <path
        d="M72.972 43.726H47.9893C45.0795 43.726 42.7206 46.084 42.7206 48.9927C42.7206 51.9015 45.0795 54.2595 47.9893 54.2595H72.972C75.8818 54.2595 78.2406 51.9015 78.2406 48.9927C78.2406 46.084 75.8818 43.726 72.972 43.726Z"
        fill={color}
        stroke={color}
        stroke-width="4.53543"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M93.1244 129.79C93.1244 129.79 122.514 79.4539 118.118 69.6347C113.719 59.823 86.068 52.6381 60.4882 52.6381C34.9083 52.6381 7.25732 59.8192 2.85795 69.6347C-1.54142 79.4501 27.8482 129.79 27.8482 129.79H93.1244Z"
        fill={color}
        stroke={color}
        stroke-width="4.53543"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M60.4882 127.79C60.4882 127.79 25.9811 127.972 16.3017 133.913C9.77449 137.919 8.23244 147.708 9.12063 157.811H111.856C112.744 147.712 111.206 137.916 104.675 133.909C94.9991 127.975 60.4882 127.79 60.4882 127.79Z"
        fill={color}
        stroke={color}
        stroke-width="4.53543"
        stroke-linejoin="round"
      />
    </svg>
  );
}
